  document.querySelectorAll('.accordion-button').forEach(button => {
    button.addEventListener('click', () => {
      button.classList.toggle('accordion-active');
      const panel = button.nextElementSibling;
      panel.style.display = panel.style.display === 'block' ? 'none' : 'block';
    });
  });


/******************End*******************/

if ($(window).width() < 750) {
  $(window).scroll(function(){
    if ($(window).scrollTop() >= 1000) {
        $('.product-form__floating-cart').addClass('sticky');
    }
    else {
        $('.product-form__floating-cart').removeClass('sticky');
    }
  });
}

if ($(window).width() < 690) {
  $(window).scroll(function(){
    if ($(window).scrollTop() >= 950) {
        $('.product-form__floating-cart').addClass('sticky');
    }
    else {
        $('.product-form__floating-cart').removeClass('sticky');
    }
  });
}


if ($(window).width() < 390) {
  $(window).scroll(function(){
    if ($(window).scrollTop() >= 750) {
        $('.product-form__floating-cart').addClass('sticky');
    }
    else {
        $('.product-form__floating-cart').removeClass('sticky');
    }
  });
}

// -------collap desc---
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.ps-accordion').forEach(button => {
    button.addEventListener('click', () => {
      button.classList.toggle('active');
      const panel = button.parentElement.nextElementSibling;
      panel.style.display = panel.style.display === 'block' ? 'none' : 'block';
    });
  });
});
